(function(angular, _) {
    'use strict';

    /**
     * Requires to be the input-number directive to be used as well.
     */
    angular.module('wtUi').directive('greaterThan', greaterThan);
    greaterThan.$inject = [];
    function greaterThan() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                ngModelCtrl.$validators.greaterThan = function(value) {
                    const _value = _.isUndefined(value) || value === null ? parseFloat(ngModelCtrl.$viewValue) : value;

                    var comparisonModel = parseFloat(attrs.greaterThan);

                    if (
                        isNaN(_value)
                        || isNaN(comparisonModel)
                        || attrs.dependantValid.toLowerCase() !== 'true'
                        || _.get(ngModelCtrl, '$error.number')
                    ) {
                        // It's valid because we have nothing to compare against or the dependant input is invalid
                        return true;
                    }

                    if (attrs.greaterThanOrEqual === 'true') {
                        return (parseFloat(_value) >= parseFloat(comparisonModel));
                    }

                    // It's valid if model is lower than the model we're comparing against
                    return (parseFloat(_value) > parseFloat(comparisonModel));
                };

                attrs.$observe('dependantValid', function() {
                    ngModelCtrl.$validate();
                });

                attrs.$observe('greaterThan', function() {
                    ngModelCtrl.$validate();
                });
            }
        };
    }
})(window.angular, window._);
